import { PatientId } from "../../../shared/schema/schema";
import MedicationTable from "./MedicationTable";

type Props = {
  /** Shows the medications without add / edit / delete / "not taking" changes. */
  isReadOnly?: boolean;
  patientId: PatientId;
  /** After each successful medication change. */
  onChanged?: () => void;
  /** Whether an add / edit / delete dialog is open. */
  onFormOpenChange?: (isOpen: boolean) => void;
  /** Whether a change without a dialog ("not taking any medications") is saving. */
  onSavingChange?: (isSaving: boolean) => void;
};

export default function PatientMedicationSection(props: Props) {
  return (
    <MedicationTable
      isReadOnly={props.isReadOnly}
      patientId={props.patientId}
      onChanged={props.onChanged}
      onFormOpenChange={props.onFormOpenChange}
      onSavingChange={props.onSavingChange}
    />
  );
}
